import { Component, inject, OnInit } from '@angular/core';

import { map } from 'rxjs/operators';

import { NotificationsFacade } from './../../+state/notifications.facade';

@Component({
    selector: 'qwyk-notifications-list-widget',
    templateUrl: './notifications-list-widget.component.html',
    styleUrls: ['./notifications-list-widget.component.scss'],
})
export class NotificationsListWidgetComponent implements OnInit {

    private notifications = inject(NotificationsFacade);

    public notifications$ = this.notifications.allNotifications$.pipe(
        map(notifications => {
            if (!notifications) {
                return notifications;
            }
            return notifications.slice(0, 5);
        })
    );
    public loading$ = this.notifications.loading$;
    public error$ = this.notifications.error$;
    public pagination$ = this.notifications.pagination$;
    private query = { page: 1, pageSize: 5 };

    ngOnInit(): void {
        this.loadQuotations(1);
    }

    private loadQuotations(page: number): void {
        if (page) {
            this.query.page = page;
        }

        this.notifications.loadNotifications(this.query);
    }
}
